import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Airplane = function Airplane(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 16 16' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    id: "vF",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "L2-shipping-lane-default",
    transform: "translate(-600.000000, -980.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(248.000000, 360.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "middle-section",
    transform: "translate(0.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shipping-tier",
    transform: "translate(16.000000, 435.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "row",
    transform: "translate(8.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.000000, 8.000000)",
    id: "Stacked-Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fastest-speed",
    transform: "translate(120.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#4D5866",
    cx: "8",
    cy: "8",
    r: "8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "1701-airplane",
    transform: "translate(2.500000, 2.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.65789474,7.53469565 L3.65789474,4.63434783 C3.65789474,4.52843478 3.59315789,4.43269565 3.49394737,4.39278261 C3.39447368,4.35286957 3.28131579,4.37608696 3.20657895,4.452 L0.799736842,6.89426087 C0.606315789,7.09043478 0.5,7.34921739 0.5,7.6233913 L0.5,8.60869565 C0.5,8.69582609 0.543947368,8.77721739 0.616578947,8.82547826 C0.660789474,8.85469565 0.711842105,8.86956522 0.763157895,8.86956522 C0.797105263,8.86956522 0.831052632,8.86330435 0.863421053,8.85 L3.495,7.776 C3.59342105,7.73582609 3.65789474,7.64034783 3.65789474,7.53469565 Z M10.2002632,6.894 L7.79342105,4.452 C7.71894737,4.37608696 7.605,4.35286957 7.50605263,4.39278261 C7.40684211,4.43269565 7.34210526,4.52843478 7.34210526,4.63434783 L7.34210526,7.53469565 C7.34210526,7.64034783 7.40657895,7.73582609 7.505,7.776 L10.1365789,8.85 C10.1689474,8.86330435 10.2028947,8.86956522 10.2368421,8.86956522 C10.2881579,8.86956522 10.3392105,8.85469565 10.3834211,8.82547826 C10.4560526,8.77721739 10.5,8.69582609 10.5,8.60869565 L10.5,7.6233913 C10.5,7.34921739 10.3936842,7.09043478 10.2002632,6.894 Z M8.04184211,10.2383478 C8.09868421,10.2881739 8.13157895,10.3596522 8.13157895,10.4347826 L8.13157895,11.7391304 C8.13157895,11.8317391 8.08210526,11.9173043 8.00184211,11.964 C7.96078947,11.988 7.91447368,12 7.86842105,12 C7.82447368,12 7.78052632,11.9890435 7.74052632,11.9671304 L5.75552632,10.874087 C5.59552632,10.785913 5.40447368,10.785913 5.24447368,10.874087 L3.25947368,11.9671304 C3.17763158,12.012 3.07842105,12.0106957 2.99815789,11.964 C2.91763158,11.9173043 2.86842105,11.8317391 2.86842105,11.7391304 L2.86842105,10.4347826 C2.86842105,10.3596522 2.90131579,10.2881739 2.95815789,10.2383478 L4.00447368,9.33104348 C4.11868421,9.23217391 4.18421053,9.08895652 4.18421053,8.93843478 L4.18421053,1.82608696 C4.18421053,0.88773913 4.82368421,0 5.5,0 C6.17631579,0 6.81578947,0.88773913 6.81578947,1.82608696 L6.81578947,8.93843478 C6.81578947,9.08895652 6.88131579,9.23217391 6.99552632,9.33104348 L8.04184211,10.2383478 Z",
    id: "Fill-274"
  }))))))))))));
};

Airplane.displayName = 'Airplane';
export default Airplane;